import { createRoot } from 'react-dom/client';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';
import './i18n';
import { AppRouterRoot } from 'App';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  integrations: [],
  environment: import.meta.env.VITE_ENV || 'development',
  enabled: ['sandbox', 'staging', 'production'].includes(
    import.meta.env.VITE_ENV as string
  ),
});

createRoot(document.getElementById('root')!).render(<AppRouterRoot />);
